import { render, staticRenderFns } from "./BulletTextFields.vue?vue&type=template&id=dfa39e4c&scoped=true&"
import script from "./BulletTextFields.vue?vue&type=script&lang=js&"
export * from "./BulletTextFields.vue?vue&type=script&lang=js&"
import style0 from "./BulletTextFields.vue?vue&type=style&index=0&id=dfa39e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa39e4c",
  null
  
)

export default component.exports